import { Component, OnInit } from '@angular/core';
import { ColumnHeader } from 'src/app/models/column-header';
import { RoutePath } from 'src/app/constants/routerPath';
import { CommonService } from 'src/app/services/common-service/common.service';
import { isPresent, isData } from 'src/app/utils/utils';
import { SrcPath } from 'src/app/constants/srcPath';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Labels } from 'src/app/constants/labels';
import { KEYS } from 'src/app/constants/keys';
import { ConfirmModalComponent } from 'src/app/components/modal/confirm-modal/confirm-modal.component';
import { CommonModule } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-admin-main',
  imports: [CommonModule],
  templateUrl: './admin-main.component.html',
  styleUrls: ['./admin-main.component.scss']
})
export class AdminMainComponent implements OnInit {
  headerData: ColumnHeader | any;
  routePath = RoutePath;
  menuTemplate: any = [];
  menuParentId = KEYS.menuParent.defaultID;

  srcPath = SrcPath;
  bsModalRef!: BsModalRef;
  labelMessages = Labels.messages;
  labelPage = Labels.page;
  labelModule = Labels.module;
  labelDashboard = Labels.dashboard;
  isSuperaDmin: boolean = false;
  superAdminStatus = KEYS.superAdminStatus;
  adminStatus = KEYS.AdminStatus;

  db_path: any;
  dbPath: string | any;
  selectedParentMenu = 0;
  pages_under_menu_group: any = []
  staticPageslist: any = [];
  adminMenuIcon = SrcPath.adminMenuIcon;
  menumoduleorderData: any = [];
  canCreatePage: any;
  canCreateModule: any;
  messageLabel = Labels.messages;

  constructor(private router: Router,
    private commonService: CommonService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.canCreatePage = this.commonService.getUserCredentials(KEYS.canCreatePage);
    this.canCreateModule = this.commonService.getUserCredentials(KEYS.canCreateModule);
    this.loadOrderMenuData(0);
    this.loadStaticMenu();
    this.isSuperAdmin();
    this.commonService.setAdminSelectedTopMenu("Dashboard");
    this.initColumnHeader();
    // this.loadMenu();

  }
  isSuperAdmin() {

    let isCredData = isPresent(JSON.parse(sessionStorage.getItem(KEYS.user_credential)!));
    if (isCredData) {
      let credData = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
      if (credData.user_Type == 1 || credData.user_Type == 3) {
        this.isSuperaDmin = true;
      } else {
        this.isSuperaDmin = false;
      }
    }
  }
  initColumnHeader() {

    this.headerData = {
      title: this.labelDashboard.admin_dashboard,
      button: {
        show: this.canCreateModule == this.superAdminStatus.yes ? true : false || this.adminStatus.yes ? true : false,
        name: this.labelModule.add_Module
      },
      topButton: {
        show: false
      }
    };
  }
  loadMenu() {
    $('.iconBlock').css('display', 'flex');
    let db_path = "";
    let path = "";
    //let db_path;
    this.route.queryParams.subscribe(params => {
      if (isPresent(params['db_path']) && (params['db_path'].length > 0)) {
        db_path = params['db_path'];
      } else {

      }
    });
    this.menuTemplate = [];
    path = JSON.parse(sessionStorage.getItem(KEYS.customerDbPath)!);


    if (db_path == "" && path != null) {
      db_path = path;
    }
    sessionStorage.setItem(KEYS.customerDbPath, JSON.stringify(db_path));
    this.dbPath = db_path;
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadMenuForAdmin(dbFullPath, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
      if (data['table']) {

        const datas = data['table'];

        this.commonService.ogLog('adminmenuid', this.menuParentId);
        const parentmenus = data['table'].filter((x: any) => x.gstibo_parent_menu_id == this.menuParentId);

        parentmenus.forEach((element: any) => {
          let childatas = datas.filter((x: any) => (x.gstibo_parent_menu_id == element.gstibo_menu_id ||
            x.parent == element.gstibo_menu_id) && x.gstibo_menu_type == 1 && x.parent_menu_id == 0);
          let staticchilddatas = [] = this.staticPageslist.filter((g: any) => g.gstibo_is_show_parentmodule_Id == element.gstibo_menu_id
            && g.gstibo_is_show_parentmodule == 'N');
          if (staticchilddatas.length > 0) {
            staticchilddatas.forEach((el: any) => {
              childatas.push(el);
            });
          }
          this.commonService.ogLog('adminmenuid', element.gstibo_menu_id);

          this.menuTemplate.push(
            {
              'gstibo_menu_name': element.gstibo_menu_name,
              'gstibo_menu_id': element.gstibo_menu_id,
              'child': (childatas
              ),
              'gstibo_menu_icon': 'timesheet', //element.gstibo_menu_icon,
              'gstibo_page_id': element.gstibo_page_id,
              'pagetype': 'D',
              'moduleorder': isPresent(this.menumoduleorderData.filter((p: any) => p.gstibo_menu_id == element.gstibo_menu_id)[0]) ? (this.menumoduleorderData.filter((p: any) => p.gstibo_menu_id == element.gstibo_menu_id)[0].gstibo_menu_listing_order) : ''
            }
          );
        });
        // const parentstmenus = this.staticPageslist.filter((x: any)=>x.gstibo_is_show_parentmodule_Id == 0);
        // parentstmenus.forEach((element:any) => {
        //       this.menuTemplate.push(
        //         {
        //           'gstibo_menu_name': element.gstibo_menu_name,
        //           'moduleid': element.gstibo_menu_id, 
        //           'gstibo_menu_icon': 'timesheet',  
        //           'pgid': element.gstibo_page_id,
        //             'child': this.staticPageslist.filter((x: any)=>( x.gstibo_is_show_parentmodule_Id ==  element.gstibo_page_id )   ),
        //         }); 
        //     });   
        this.menuTemplate = this.menuTemplate.sort((a: any, b: any) => (a.moduleorder - b.moduleorder));
        this.commonService.ogLog('adminmenus', this.menuTemplate);
      }
    });

  }
  viewPage(data: any) {
    this.commonService.ogLog('data : ', data);
    const pageDetails = {
      pageId: data.gstibo_page_id,
      pageName: data.gstibo_page_name
    }
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    this.router.navigate([RoutePath.mainPageLayout, pageDetails.pageName]);
  }
  addNewPage(menu_id: any) {
    let data = {
      inputMode: KEYS.actionType.add,
      pageId: '0'
    };
    this.router.navigate([this.routePath.createNewPage],
      {
        queryParams: data
      });
  }
  editPage(data: any) {
    // let data1 = {
    //   inputMode: KEYS.actionType.edit,
    //   menuId: KEYS.menuId.defaultID,
    //   pageId: data.gstibo_page_id,
    //   pageName: data.gstibo_page_name,
    //   pageDescription: data.gstibo_app_description,
    //   pageIcon: data.gstibo_icon,
    //   pageBgColor: data.gstibo_bg_color,
    //   iconStyle: data.gstibo_menu_style,
    //   linkPageId: data.gstibo_linked_page,
    //   staticDataPageId: data.gstibo_linked_page_static,
    //   popupWidthClass: data.gstibo_popup_width
    // };
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadPageDetailsById(dbFullPath, data['gstibo_page_id']).subscribe((adata: any) => {
      isData(adata)
      {
        sessionStorage.setItem(KEYS.pageDetailsEdit, JSON.stringify(adata['table'][0]));
        this.router.navigate([RoutePath.createNewPage],
          {
            queryParams: {
              pageId: data['gstibo_page_id'],
              pageDetails: JSON.stringify(adata['table'][0])
            }
          });
      }
    });

  }
  deletePage(page_id: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.bsModalRef = this.modalService.show(ConfirmModalComponent, {
      animated: true, class: KEYS.confirmModal
    });
    this.bsModalRef.content.data = {
      title: this.labelMessages.delete_confirm_msg.title,
      message: this.labelMessages.delete_confirm_msg.message,
      btnConfirm: this.labelMessages.delete_confirm_msg.btnDelete,
      btnCancel: this.labelMessages.delete_confirm_msg.btnCancel,
      btnConfirmStyle: 'btn-red',
      btnCancelStyle: 'btn-green'
    }
    this.bsModalRef.content.buttonevent.subscribe((res: any) => {
      if (res) {
        this.commonService.deletePage(
          dbFullPath,
          page_id,
          this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
            if (isData(data)) {
              let pageTblCnt = (data['table'][0]).tbl_cnt;
              if (pageTblCnt > 0) {
               // this.toastr.error('Cannot be deleted. Data already used.');
               this.commonService.showModalValidate('Cannot be deleted. Data already used.','',this.messageLabel.static_messages.warning,'Cannot be deleted. Data already used.');
              }
              else {
               // this.toastr.error(this.labelMessages.delete_success_msg.message);
               this.commonService.showModalValidate(this.labelMessages.delete_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.delete_success_msg.message);
                this.loadMenu();
              }
            }
          });
      }
    });
  }
  editMenu(data1: any) {
    this.router.navigate([this.routePath.createModule],
      {
        queryParams:
        {
          inputMode: KEYS.actionType.edit,
          menuId: data1.gstibo_menu_id,
          menuName: data1.gstibo_menu_name,
          menuIcon: data1.gstibo_menu_icon,
          menuType: this.menuParentId,
          menuPageId: data1.gstibo_page_id
        }
      });
  }
  deleteMenu(menu_id: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.bsModalRef = this.modalService.show(ConfirmModalComponent, {
      animated: true, class: KEYS.confirmModal
    });
    this.bsModalRef.content.data = {
      title: this.labelMessages.delete_confirm_msg.title,
      message: this.labelMessages.delete_confirm_msg.message,
      btnConfirm: this.labelMessages.button_confirm.message,
      btnCancel: this.labelMessages.button_cancel.message,
      btnConfirmStyle: 'btn-red',
      btnCancelStyle: 'btn-green'
    }
    this.bsModalRef.content.buttonevent.subscribe((res: any) => {
      if (res) {
        this.commonService.deleteModule(
          dbFullPath,
          menu_id,
          this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
            //this.toastr.error(this.labelMessages.delete_success_msg.message);
            this.commonService.showModalValidate(this.labelMessages.delete_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.delete_success_msg.message);
            this.loadMenu();
            this.loadStaticMenu();
          });
      }
    });
  }
  addNewMenu() {
    this.router.navigate([this.routePath.createMenu], { queryParams: { inputMode: KEYS.actionType.add } });
  }
  addModule() {
    this.router.navigate([this.routePath.createModule], { queryParams: { inputMode: KEYS.actionType.add } });
  }
  backBtnClick(data: any) {
    this.selectedParentMenu = 0;
  }
  openPagesUnderMenu(data: any, menu_id: any) {
    this.selectedParentMenu = data.gstibo_menu_id;
    let menuId = menu_id
    this.getChildPages(menuId);
  }
  getChildPages(menuId: any) {
    $('.iconBlock').css('display', 'flex');
    let db_path = "";
    let path = "";
    //let db_path;
    this.route.queryParams.subscribe(params => {
      if (isPresent(params['db_path']) && (params['db_path'].length > 0)) {
        db_path = params['db_path'];
      } else {

      }
    });
    this.pages_under_menu_group = [];
    path = JSON.parse(sessionStorage.getItem(KEYS.customerDbPath)!);
    if (db_path == "" && path != null) {
      db_path = path;
    }
    sessionStorage.setItem(KEYS.customerDbPath, JSON.stringify(db_path));
    this.dbPath = db_path;
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadChildPages(dbFullPath, menuId).subscribe((data: any) => {
      if (data['table']) {
        const datas = data['table'];
        //const parentmenus = data['table'].filter((x: any)=>x.gstibo_parent_menu_id == this.menuParentId);
        datas.forEach((element: any) => {
          this.pages_under_menu_group.push(
            {
              'gstibo_menu_name': element.gstibo_page_name,
              'gstibo_menu_id': element.gstibo_menu_id,
              'child': datas.filter((x: any) => (x.gstibo_parent_menu_id == element.gstibo_menu_id ||
                x.parent == element.gstibo_menu_id) && x.gstibo_menu_type == 1),
              'gstibo_menu_icon': element.gstibo_menu_style,
              'gstibo_page_id': element.gstibo_page_id,
              'gstibo_icon': element.gstibo_icon,
              'gstibo_page_name': element.gstibo_page_name
            }
          );
        });
      }
    });
  }
  editSubMenu(data: any) {
    let menuDetails: any = [];
    menuDetails.push(data);
    this.commonService.ogLog('menuDetails:', menuDetails);
    this.router.navigate([RoutePath.createMenu],
      {
        queryParams: {
          menu_id: data.gstibo_menu_id,
          menuDetails: JSON.stringify(menuDetails)
        }
      });
  }
  loadStaticMenu() {

    let userAccountID = this.commonService.getUserCredentials(KEYS.credential_customer_id);
    this.commonService.loadStaticMenuForUser(userAccountID).subscribe((data: any) => {
      if (isData(data)) {
        this.staticPageslist = [];
        this.staticPageslist = data['table'];
        const parentstmenus = this.staticPageslist.filter((x: any) => x.gstibo_is_show_parentmodule_Id == 0);
        parentstmenus.forEach((element: any) => {
          let ch: any = [];
          let df = this.staticPageslist.filter((x: any) => (x.gstibo_is_show_parentmodule_Id == element.gstibo_page_id));
          df.forEach((element: any) => {
            ch.push({
              'gstibo_menu_name': element.gstibo_menu_name,
              'moduleid': element.gstibo_menu_id,
              'gstibo_menu_id': element.gstibo_menu_id,
              'gstibo_menu_icon': element.gstibo_icon,
              'gstibo_icon': element.gstibo_icon,
              'pgid': element.gstibo_page_id,
              'pagetype': 'S',
              'gstibo_is_show_parentmodule_Id': element.gstibo_is_show_parentmodule_Id,
              'gstibo_is_show_parentmodule': element.gstibo_is_show_parentmodule,
              'gstibo_listing_order': element.gstibo_listing_order,
              'gstibo_parent_menu_id': element.gstibo_is_show_parentmodule_Id,
              'moduleorder': (element.gstibo_menu_name == 'Settings' ? 20 : element.moduleorder),
              'gstibo_is_hide': element.gstibo_is_hide

            })
          })
          this.menuTemplate.push(
            {
              'gstibo_menu_name': element.gstibo_menu_name,
              'moduleid': element.gstibo_menu_id,
              'gstibo_menu_id': element.gstibo_menu_id,
              'gstibo_menu_icon': 'expensesheet',
              'gstibo_icon': element.gstibo_icon,
              'pgid': element.gstibo_page_id,
              'child': ch,
              'pagetype': 'S',
              'moduleorder': (element.gstibo_menu_name == 'Settings' ? 20 : element.moduleorder)
            });
        });
      }
    });
  }
  loadOrderMenuData(menuid: any) {
    this.commonService.getModulemenuorderlist(menuid).subscribe((data: any) => {
      if (isData(data)) {
        if (this.menumoduleorderData.length == 0) {
          this.menumoduleorderData = data['table'];
          this.loadMenu();
        }
      }
    });
  }
}
